module.exports = __webpack_public_path__ + "img/Icon-offline.1d824299.svg";